import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';

function Modal(props) {
    const {
        title = '',
        showHeader = true,
        showClose = true,
        children,
        onCloseClick = e => e
    } = props;

    let header = null,
        modalCls = 'modal animated bounceIn';
    if (showHeader) {
        header = (
            <div className="modal-header">
                <h3 className="modal-title text-center">{title}</h3>
                {showClose ? <span className="modal-close text-center" onClick={onCloseClick}/> : null}
            </div>
        );
    }
    if (!title && showHeader) {
        //  content的padding需要减少一下
        modalCls = 'modal modal-empty-header animated bounceIn';
    }
    return (
        <div
            className="modal-backdrop">
            <div className={modalCls}>
                {header}
                <div className="modal-content">
                    {children}
                </div>
            </div>
        </div>
    );
}

// 自动创建节点，显示的时候创建，不显示的时候直接销毁就OK
// 使用单例，防止页面由多个弹出框
// 全局存储的元素和react元素，重新打开的时候需要销毁之前的实例
let el = null, element = null;

/**
 * 此处需要优化
 * @param title 显示的title
 * @param children
 * @param showHeader 显示头部
 * @param extraClass 扩展的css类，用来扩展的
 * @param showClose 显示右上角的关闭按钮
 * @returns {function()}
 */
const create = (title, children, showHeader = true, extraClass = '', showClose = true) => {
    destroy();
    // 重新创建下el和element
    el = document.createElement('div');
    extraClass && el.classList.add(extraClass);
    document.body.appendChild(el);
    element = ReactDOM.render((
        <Modal title={title} showHeader={showHeader} showClose={showClose} onCloseClick={destroy}>
            {children}
        </Modal>
    ), el);
    return destroy; //  执行返回的对象可以销毁这个框框
};

const createNoHeader = (children, extraClass = '') => {
    return create('', children, false, extraClass);
};

const destroy = () => {
    if (el) {
        const classList = el.querySelector('.modal').classList;
        classList.remove('bounceIn');
        classList.add('bounceOut');
    }
    if (element || el) {
        setTimeout(() => {
            if (element) {
                ReactDOM.unmountComponentAtNode(el);
                element = null;
            }
            if (el) {
                document.body.removeChild(el);
                el = null;
            }
        }, 250);
    }
};

//  监听esc键，关闭弹窗
const modalListen = window.modalListen;
if (!modalListen) {
    document.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
            destroy();
        }
    });
    window.modalListen = true;
}

export default {
    create,
    createNoHeader,
    destroy
};



// WEBPACK FOOTER //
// ./js/component/modal/index.js